/* Product page fitment (rickspartsusa.com) — port of the fitment parts of Henne's henne-pdp.js.
 * 1. Fit check (snippets/ymm-pdp-fitment.liquid, mode check): compares the product's bike collections with the
 *    bike saved by the Harley finder (localStorage ymm_bike) and offers an inline Year/Family/Model picker.
 * 2. Fitment list filter (mode list). */
(function () {
  if (window.YmmPdp) return;

  var STORAGE_KEY = "ymm_bike";
  var indexPromise = null;

  function readBike() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var bike = raw ? JSON.parse(raw) : null;
      return bike && bike.handle && bike.model ? bike : null;
    } catch (e) {
      return null;
    }
  }

  function saveBike(bike) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(bike));
    } catch (e) {}
  }

  function loadIndex(url) {
    if (!indexPromise) {
      indexPromise = fetch(url, { credentials: "same-origin" })
        .then(function (r) {
          if (!r.ok) throw new Error("index " + r.status);
          return r.json();
        })
        .catch(function (e) {
          indexPromise = null;
          throw e;
        });
    }
    return indexPromise;
  }

  function fill(select, placeholder, values) {
    select.replaceChildren();
    var empty = document.createElement("option");
    empty.value = "";
    empty.textContent = placeholder;
    select.append(empty);
    values.forEach(function (v) {
      var o = document.createElement("option");
      o.value = String(v);
      o.textContent = String(v);
      select.append(o);
    });
    select.disabled = values.length === 0;
  }

  /* ---------- 1. Fit check ---------- */
  function initFitCheck(root) {
    if (root.dataset.ymmReady) return;
    root.dataset.ymmReady = "1";
    var data = root.querySelector("[data-ymm-bikes]");
    var bikes = {};
    try {
      JSON.parse(data.textContent).forEach(function (h) { bikes[h] = true; });
    } catch (e) {
      return;
    }
    var states = root.querySelectorAll("[data-ymm-state]");
    var picker = root.querySelector("[data-ymm-fit-picker]");
    var status = root.querySelector("[data-ymm-pick-status]");
    var openers = root.querySelectorAll("[data-ymm-fit-open]");
    var pick = {
      year: root.querySelector('[data-ymm-pick="year"]'),
      family: root.querySelector('[data-ymm-pick="family"]'),
      model: root.querySelector('[data-ymm-pick="model"]'),
    };
    var index = null;

    function label(bike) {
      return bike.year + " " + bike.model;
    }

    function show(name, bike) {
      states.forEach(function (el) { el.hidden = el.dataset.ymmState !== name; });
      if (bike) {
        root.querySelectorAll("[data-ymm-bike-label]").forEach(function (el) { el.textContent = label(bike); });
        var parts = root.querySelector("[data-ymm-bike-parts]");
        if (parts) {
          parts.href = root.dataset.collectionsUrl.replace(/\/?$/, "/") + encodeURIComponent(bike.handle);
          parts.textContent = "See parts that fit your " + label(bike);
          parts.hidden = name !== "no";
        }
      }
    }

    function render() {
      var bike = readBike();
      if (!bike) show("unknown");
      else show(bikes[bike.handle] ? "yes" : "no", bike);
    }

    function setOpen(open) {
      picker.hidden = !open;
      openers.forEach(function (b) { b.setAttribute("aria-expanded", open ? "true" : "false"); });
    }

    function families() {
      var y = index && index.y[pick.year.value];
      if (!y) return [];
      var order = index.families || [];
      var rank = function (f) { var i = order.indexOf(f); return i === -1 ? order.length : i; };
      return Object.keys(y).sort(function (a, b) { return rank(a) - rank(b) || a.localeCompare(b); });
    }

    function models() {
      var y = index && index.y[pick.year.value];
      return (y && y[pick.family.value]) || [];
    }

    function preselect() {
      var bike = readBike();
      fill(pick.year, "Year", index.years);
      if (bike && index.y[bike.year]) {
        pick.year.value = String(bike.year);
        fill(pick.family, "Family", families());
        pick.family.value = bike.family || "";
        fill(pick.model, "Model", models().map(function (e) { return e.m; }));
        pick.model.value = bike.model || "";
      } else {
        fill(pick.family, "Family", []);
        fill(pick.model, "Model", []);
      }
    }

    function open() {
      setOpen(true);
      if (index) {
        preselect();
        pick.year.focus();
        return;
      }
      status.hidden = false;
      status.textContent = "Loading motorcycles…";
      loadIndex(root.dataset.indexUrl)
        .then(function (d) {
          index = d;
          status.hidden = true;
          preselect();
          pick.year.focus();
        })
        .catch(function () {
          status.textContent = "Could not load motorcycles. Please try again.";
        });
    }

    openers.forEach(function (b) {
      b.addEventListener("click", function () {
        if (picker.hidden) open();
        else setOpen(false);
      });
    });

    // Keep the previous value when it still exists (e.g. only the year changed), else auto-pick a single option.
    function refill(select, placeholder, values) {
      var prev = select.value;
      fill(select, placeholder, values);
      if (values.indexOf(prev) !== -1) select.value = prev;
      else if (values.length === 1) select.value = values[0];
    }

    function commit() {
      var entry = models().filter(function (e) { return e.m === pick.model.value; })[0];
      if (!entry) return;
      saveBike({ year: pick.year.value, family: pick.family.value, model: entry.m, handle: entry.h });
      setOpen(false);
      render();
      var focusTarget = root.querySelector("[data-ymm-state]:not([hidden]) [data-ymm-fit-open]");
      if (focusTarget) focusTarget.focus();
    }

    picker.addEventListener("change", function (event) {
      var field = event.target.dataset.ymmPick;
      if (!field || !index) return;
      if (field === "year") refill(pick.family, "Family", families());
      if (field === "year" || field === "family") {
        refill(pick.model, "Model", pick.family.value ? models().map(function (e) { return e.m; }) : []);
      }
      if (pick.model.value) commit();
    });

    window.addEventListener("storage", function (event) {
      if (event.key === STORAGE_KEY) render();
    });
    render();
  }

  /* ---------- 2. Fitment list filter ---------- */
  function initFitList(root) {
    if (root.dataset.ymmReady) return;
    root.dataset.ymmReady = "1";
    var more = root.querySelector("[data-ymm-fit-more]");
    if (more) {
      more.addEventListener("click", function () {
        root.classList.remove("ymm-fit--collapsed");
        more.hidden = true;
        more.setAttribute("aria-expanded", "true");
      });
    }
    var input = root.querySelector("[data-ymm-fit-filter]");
    if (!input) return;
    var rows = Array.prototype.slice.call(root.querySelectorAll("[data-ymm-fit-row]"));
    var empty = root.querySelector("[data-ymm-fit-empty]");
    input.addEventListener("input", function () {
      var words = input.value.toLowerCase().split(/\s+/).filter(Boolean);
      var shown = 0;
      root.classList.toggle("ymm-fit--filtering", words.length > 0);
      rows.forEach(function (row) {
        var text = row.textContent.toLowerCase();
        var ok = words.every(function (w) { return text.indexOf(w) !== -1; });
        row.hidden = !ok;
        if (ok) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    });
  }

  function initAll(scope) {
    var s = scope || document;
    s.querySelectorAll("[data-ymm-fitcheck]").forEach(initFitCheck);
    s.querySelectorAll("[data-ymm-fit-list]").forEach(initFitList);
  }

  window.YmmPdp = { initAll: initAll };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", function (event) { initAll(event.target); });
})();
